__turbopack_context__.v({
  "rawTable": "PlasmicTable-module__LkNUPG__rawTable",
  "table": "PlasmicTable-module__LkNUPG__table",
  "tableTbody___9Sp9T": "PlasmicTable-module__LkNUPG__tableTbody___9Sp9T",
  "tableTd__oboo2": "PlasmicTable-module__LkNUPG__tableTd__oboo2",
  "tableTd__ozvr7": "PlasmicTable-module__LkNUPG__tableTd__ozvr7",
  "tableTd__tk22X": "PlasmicTable-module__LkNUPG__tableTd__tk22X",
  "tableTd__yJsY": "PlasmicTable-module__LkNUPG__tableTd__yJsY",
  "tableTh___9I6A5": "PlasmicTable-module__LkNUPG__tableTh___9I6A5",
  "tableTh__egg6U": "PlasmicTable-module__LkNUPG__tableTh__egg6U",
  "tableTh__pYjac": "PlasmicTable-module__LkNUPG__tableTh__pYjac",
  "tableTh__srbkf": "PlasmicTable-module__LkNUPG__tableTh__srbkf",
  "tableThead__vyONq": "PlasmicTable-module__LkNUPG__tableThead__vyONq",
  "tableTr___08JVq": "PlasmicTable-module__LkNUPG__tableTr___08JVq",
  "tableTr__dkcak": "PlasmicTable-module__LkNUPG__tableTr__dkcak",
  "text___4SCh": "PlasmicTable-module__LkNUPG__text___4SCh",
  "text___6S7DM": "PlasmicTable-module__LkNUPG__text___6S7DM",
  "text__buZjd": "PlasmicTable-module__LkNUPG__text__buZjd",
  "text__pf5Fg": "PlasmicTable-module__LkNUPG__text__pf5Fg",
});
